import { ArrowsClockwiseIcon } from "@phosphor-icons/react";

interface BidMidAskProps {
  bid: string;
  mid: string;
  ask: string;
  lastUpdated: string | undefined;
  onRefreshQuoteClicked: () => void;
}

export const BidMidAsk = ({
  bid,
  mid,
  ask,
  lastUpdated,
  onRefreshQuoteClicked,
}: BidMidAskProps) => (
  <div className="flex flex-col gap-2 py-2">
    <div className="flex w-full items-end justify-between">
      <div className="flex flex-col items-start gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-700 leading-[14px]">Bid</p>
        <p className="m-0 p-0 font-mono text-emerald-600 text-sm leading-5">
          {bid}
        </p>
      </div>
      <div className="h-[22px] w-px self-end bg-gray-200" />
      <div className="flex flex-col items-center gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-700 leading-[14px]">Mid</p>
        <p className="m-0 p-0 font-medium font-mono text-gray-800 text-sm leading-5">
          {mid}
        </p>
      </div>
      <div className="h-[22px] w-px self-end bg-gray-200" />
      <div className="flex flex-col items-end gap-0.5">
        <p className="m-0 p-0 text-[10px] text-gray-700 leading-[14px]">Ask</p>
        <p className="m-0 p-0 font-mono text-red-500 text-sm leading-5">
          {ask}
        </p>
      </div>
    </div>
    <div className="flex items-center justify-end gap-1">
      <p className="m-0 p-0 font-mono text-gray-500 text-xs">{lastUpdated}</p>
      <button
        aria-label="Refresh quote"
        onClick={onRefreshQuoteClicked}
        type="button"
      >
        <ArrowsClockwiseIcon
          size={16}
          className="text-indigo-600 hover:text-indigo-500 active:text-indigo-400"
        />
      </button>
    </div>
  </div>
);
